import { AccountsResponseDto } from '~/models/accounts/accounts';
import { accountsApi } from '../apis/endpoints/myQredApi/accounts/accounts.api';
import { createSlice } from '@reduxjs/toolkit';

export interface AccountState {
  account?: AccountsResponseDto;
}

const initialState: AccountState = {};

const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      accountsApi.endpoints.getAccounts.matchFulfilled,
      (state, { payload }) => ({
        ...state,
        ...payload,
      })
    );
  },
});
export default accountSlice.reducer;
